'use client'

import Link from 'next/link'
import { useHelpPages } from '@/hooks/business/pages/useHelpPages'

interface IHelpSidebarProps {
    slug: string
}

/** Menu lateral da página do CMS: a categoria da página e os artigos dela. */
const HelpSidebar: React.FC<IHelpSidebarProps> = ({ slug }) => {
    const { list, tree } = useHelpPages()

    const current = list.find((p) => p.slug === slug)
    const categoryId = current?.parentId ?? current?.id
    const category = tree.find((n) => n.id === categoryId)

    // Sem sidebar para páginas avulsas (sem categoria com irmãs).
    if (!category || category.children.length === 0) return null

    return (
        <aside className="w-[260px] shrink-0 max-lg:w-full">
            <nav className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <Link href={`/p/${category.slug}`} className="block font-bold text-primary mb-3">
                    {category.name}
                </Link>
                <ul className="flex flex-col gap-2">
                    {category.children.map((child) => (
                        <li key={child.id}>
                            <Link
                                href={`/p/${child.slug}`}
                                className={`text-sm hover:text-primary ${
                                    child.slug === slug ? 'text-accent font-bold' : 'text-gray-600'
                                }`}
                            >
                                {child.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    )
}

export default HelpSidebar
